export const CSS_UID = 'select-button-1fc12176-3edd-46fa-b8d9-23ed84d4710e';
